var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'home' }},nativeOn:{"click":function($event){return _vm.$store.commit('setCurrentSlide', 0)}}},[_c('img',{staticClass:"img",attrs:{"src":"/images/logo.svg","alt":"Królewskie"}})])}
var staticRenderFns = []

export { render, staticRenderFns }